export const formatNumber = (value = 0) =>
  new Intl.NumberFormat(undefined, { notation: value > 9999 ? "compact" : "standard" }).format(value);

export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;
  return date.toLocaleDateString(undefined, { month: "short", year: "numeric" });
};

export const normalize = (value = "") => value.toString().trim().toLowerCase();

export const matchesQuery = (value = "", query = "") => {
  if (!query) return true;
  return normalize(value).includes(normalize(query));
};

export const uniqueValues = (items = [], key) => {
  if (!key) return [];
  return Array.from(new Set(items.map((item) => item[key]).filter(Boolean))).sort();
};
